import "../styles/navbar.css"
import { useRef } from "react"; //useEffect as reactuseEffect, useState, 
import { HiDownload } from "react-icons/hi";
import name_logo from '../images/name_logo.png'
import {
  Box,
  Flex,
  Button,
  useDisclosure,
  useColorModeValue,
  Stack,
  useColorMode,
  Center,
} from '@chakra-ui/react';
import { MoonIcon, SunIcon } from '@chakra-ui/icons';
import {  Link as RouterLink } from "react-router-dom" //Navigate,useNavigate

export const Navbar = () => {

  const homeRef = useRef(null);
  const aboutRef = useRef(null);
  const skillsRef = useRef(null);
  const projectsRef = useRef(null);
  const contactRef = useRef(null);
  const scrollToRef = (ref) => {
    if (ref && ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const { colorMode, toggleColorMode } = useColorMode();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const Opentab = () => {
    window.open("/pdf/amir_khan_resume.pdf", "_blank")
  }


  return (
    <>
      <Box
      id="parent_Box"
        h={"70px"}
        position={"fixed"}
        zIndex={"3"}
        width={"100%"}
        marginBottom={"170px"}
        top={"0px"}
        bg={useColorModeValue('gray.100', 'gray.900')}
        px={4} display={"flex"} justifyContent={"space-between"}>

        <Box w={"17%"} padding={'5px'} id="name_Box" 
      >
          
          <img src={name_logo} alt="name logo" />
        </Box>

        <Box h={16} w={"60%"} justifyContent={'space-between'} alignItems={"center"} display={"flex"} fontWeight={"700"} 
        id="pages_Box"  
      >

          <a href="#home" onClick={() => scrollToRef(homeRef)}>Home</a>
          <a href="#about" onClick={() => scrollToRef(aboutRef)}>About</a>
          <a href="#skills" onClick={() => scrollToRef(skillsRef)}>Skills</a>
          <a href="#projects" onClick={() => scrollToRef(projectsRef)}>Projects</a>
          <a href="#contact" onClick={() => scrollToRef(contactRef)}>Contact</a>


          <RouterLink to="/pdf/amir_khan_resume.pdf"
            target="_blank" download>
            <button className="download_resume" onClick={Opentab}>Resume
              <HiDownload></HiDownload>
            </button>
          </RouterLink>

          <Flex alignItems={'center'}  >
            <Stack direction={'row'} spacing={7} id="theme_Button" >
              <Button onClick={toggleColorMode}>
                {colorMode === 'light' ? <MoonIcon /> : <SunIcon />}
              </Button>
            </Stack>
          </Flex>

        </Box>

      </Box>
    </>
  );
}